import { addSharedHooks } from './shared-lib';
import useDetailBreadCrumb from '@/pages/activity-manage/merchants/detail/hooks/use-detail-bread-crumbs';

addSharedHooks('useDetailBreadCrumb', useDetailBreadCrumb);
